/* eslint-disable react-hooks/exhaustive-deps */
import { useRef, useEffect } from 'react';
import useSliderState from './useSliderState';
import SliderRail from './SliderRail';
import ProgressBars from './ProgressBars';
import SlidableZone from './SlidableZone';

type RubricsSliderProps = {
  studentProgress: number;
  coachProgress: number;
  levelCount: number;
  onSlide: (progress: number) => void;
  onSlideStop: (progress: number) => void;
  readOnly: boolean;
  disabled: boolean;
};

// TODO remaining readOnly -> readonly (everywhere, all files)
const RubricsSlider = ({
  studentProgress,
  coachProgress,
  levelCount,
  onSlide,
  onSlideStop,
  readOnly,
  disabled,
}: RubricsSliderProps) => {
  const sliderRef = useRef<HTMLDivElement>(null);
  const {
    isSliding,
    progress,
    handleMouseMove,
    handleMouseMoveActivate,
    handleMouseMoveDeactivate,
  } = useSliderState(readOnly || disabled, sliderRef);

  useEffect(() => {
    if (progress !== null) {
      const handleProgressChange = isSliding ? onSlide : onSlideStop;
      handleProgressChange(progress);
    }
  }, [isSliding, progress]);

  return (
    <SliderRail
      levelCount={levelCount}
      onMouseMoveActivate={handleMouseMoveActivate}
      onMouseMoveDeactivate={handleMouseMoveDeactivate}
      onMouseMove={handleMouseMove}
      readOnly={readOnly}
      disabled={disabled}
      ref={sliderRef}
    >
      <ProgressBars
        studentProgress={studentProgress}
        coachProgress={coachProgress}
        isSliding={isSliding}
      />
      {!readOnly && !disabled && <SlidableZone />}
    </SliderRail>
  );
};

export default RubricsSlider;
